export default "__VITE_ASSET__sa6Mnr0S__"